import { Edit3 } from 'blaze-ui/icons'
import { HoverActionOverlay, HoverActionOverlayProps } from 'components/HoverActionOverlay/HoverActionOverlay'
import { DOC_PATH } from 'paths'
import { generatePath, useHistory } from 'react-router-dom'

export const EditInDocumentOverlay = ({
  onAction,
  onClose,
  ...props
}: Omit<HoverActionOverlayProps, 'onAction' | 'buttonLabel'> & { almanacFileKey: string; onAction?: () => void }) => {
  const history = useHistory()

  const onEdit = () => {
    onClose?.()
    history.push(generatePath(DOC_PATH, { slug: props.almanacFileKey }))
  }
  return (
    <HoverActionOverlay
      {...props}
      onAction={onAction || onEdit}
      buttonLabel="Edit Document"
      scrimOpacity={20}
      buttonProps={{
        frontIcon: Edit3,
        variant: 'secondary',
        size: 'lg',
        ...props.buttonProps,
      }}
    >
      {props.children}
    </HoverActionOverlay>
  )
}
